import { Pipe, PipeTransform } from '@angular/core';

import { CacheDateItem } from '../../../insight/performance-data/cache-date.pd.model';
import { formatCacheDate } from '../../builder-selection';

@Pipe({
    name: 'cmpsReportBuilderCacheDate',
})
export class CacheDatePipe implements PipeTransform {
    transform(value: CacheDateItem | null): string {
        return formatCacheDate(
            value.periodType,
            value.startDate,
            value.endDate,
        );
    }
}
